export default __webpack_public_path__ + "static/media/gallery_03.3e760684.jpg";